export default __webpack_public_path__ + "static/media/tutorialVideo.ccb4e77c.mp4";